import styles from "@/components/beta-watermark.module.css";
import { JSX } from "react";

function BetaWatermark(): JSX.Element {
	if (window.location.hostname !== "beta.limestart.cn") {
		return <></>;
	}
	return (
		<div className={styles["beta-watermark"]}>
			内测版本不建议日常使用
			<div>用户反馈群：941653619</div>
		</div>
	);
}

export default BetaWatermark;
